module.exports = __webpack_public_path__ + "img/noimg.a0e06339.jpg";